import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { userScopeCleared } from '@krp/client-runtime'
import type { CashierLinksDraft } from './types'

/**
 * Намерение окна «Связи кассиров»: черновик связи и месяц, за который источники показывают кассиров.
 * Группы, кандидаты и история — в кэше запросов. Пустой месяц означает «текущий»: его считает привязка по времени источника.
 */
export interface CashierGroupsIntent { draft: CashierLinksDraft | null; month: string }
const initialState: CashierGroupsIntent = { draft: null, month: '' }
const slice = createSlice({ name: 'cashierGroups', initialState, reducers: {
  cashierGroupsPatched: (state, action: PayloadAction<Partial<CashierGroupsIntent>>) => { Object.assign(state, action.payload) },
  cashierGroupDraftPatched: (state, action: PayloadAction<Partial<CashierLinksDraft>>) => { if (state.draft !== null) Object.assign(state.draft, action.payload) },
}, extraReducers: (builder) => {
  builder.addCase(userScopeCleared, () => initialState)
} })
export const { cashierGroupsPatched, cashierGroupDraftPatched } = slice.actions
export const cashierGroupsReducer = slice.reducer
